import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { saveAuth } from "@/lib/api";
import Nav from "@/components/Nav";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const startGoogle = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Auth() {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const path = mode === "login" ? "/auth/login" : "/auth/signup";
      const body = mode === "login" ? { email, password: pw } : { email, password: pw, name };
      const { data } = await api.post(path, body);
      saveAuth(data);
      toast.success(mode === "login" ? "Welcome back" : "Account created");
      nav(data.user?.role === "SUPER_ADMIN" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Auth failed");
    } finally { setLoading(false); }
  };

  return (
    <div>
      <Nav />
      <div className="max-w-md mx-auto px-5 py-14">
        <div className="rounded-2xl bg-[#131E36] border border-[#E0A96D]/10 p-8 fade-up">
          <div className="uppercase font-mono text-xs tracking-[0.24em] text-[#E0A96D] mb-2">DualQ Account</div>
          <h1 className="font-serif text-3xl mb-6">{mode === "login" ? "Sign in" : "Create an account"}</h1>
          <form onSubmit={submit} className="space-y-3">
            {mode === "signup" && (
              <input type="text" placeholder="Your name" value={name} onChange={(e)=>setName(e.target.value)}
                className="w-full px-4 py-3 rounded-lg bg-[#0E172A] border border-slate-700 focus:border-[#E0A96D] outline-none" data-testid="auth-name" />
            )}
            <input type="email" required placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-lg bg-[#0E172A] border border-slate-700 focus:border-[#E0A96D] outline-none" data-testid="auth-email" />
            <input type="password" required placeholder="Password" value={pw} onChange={(e)=>setPw(e.target.value)}
              className="w-full px-4 py-3 rounded-lg bg-[#0E172A] border border-slate-700 focus:border-[#E0A96D] outline-none" data-testid="auth-password" />
            <button type="submit" disabled={loading}
              className="w-full py-3 rounded-lg bg-[#E0A96D] text-[#070C18] font-semibold hover:bg-[#F0C28B] transition-colors" data-testid="auth-submit">
              {loading ? "Please wait…" : (mode === "login" ? "Sign in" : "Create account")}
            </button>
          </form>
          <div className="relative my-4">
            <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-slate-800"></div></div>
            <div className="relative flex justify-center text-xs"><span className="bg-[#131E36] px-2 text-slate-500 font-mono">or</span></div>
          </div>
          <button onClick={startGoogle}
            className="w-full py-3 rounded-lg bg-white text-slate-900 font-medium hover:bg-slate-200 transition-colors flex items-center justify-center gap-2"
            data-testid="google-signin-btn">
            <svg className="w-4 h-4" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.9 32.6 29.4 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.2 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.2 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.3 0 10.1-2 13.7-5.3l-6.3-5.3C29.3 34.7 26.8 36 24 36c-5.4 0-9.9-3.4-11.6-8l-6.5 5C9.4 39.6 16.1 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4 5.6l6.3 5.3C41.4 36.5 44 30.8 44 24c0-1.3-.1-2.3-.4-3.5z"/></svg>
            Continue with Google
          </button>
          <button onClick={()=>setMode(mode==="login"?"signup":"login")}
            className="w-full text-sm text-slate-400 mt-4 hover:text-[#E0A96D]" data-testid="auth-toggle">
            {mode === "login" ? "New here? Create an account." : "Already have an account? Sign in."}
          </button>
          <button onClick={()=>nav("/reset")} className="w-full text-xs text-slate-500 mt-2 hover:text-slate-300" data-testid="auth-forgot">
            Forgot your password?
          </button>
        </div>
      </div>
    </div>
  );
}
